<div id="accordionPosProducts">
  <dq-accordion id="posProducts" icon="icon-producto.svg" label="Productos">
    <div class="card-body px-0">
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-3">
              <dq-combo
                id="brandProducCombo"
                [items]="brands"
                (selectedItemEvent)="changeBrand($event)"
                label="{{ 'filters.brand' | translate }}"
                (unselectItemEvent)="unselectedBrand($event)"
                [selected]="last_filter_selection.brand"
              ></dq-combo>
            </div>

            <div class="col-md-3">
              <dq-combo
                id="subbrandProducCombo"
                [items]="subbrands"
                (selectedItemEvent)="changeSubBrand($event)"
                label="{{ 'filters.sub-brand' | translate }}"
                (unselectItemEvent)="unselectedSubBrand($event)"
                [disabled]="
                  last_filter_selection.brand == '' ||
                  last_filter_selection.brand == null
                "
                [selected]="last_filter_selection.subbrand"
              ></dq-combo>
            </div>

            <div class="col-md-3">
              <dq-combo
                id="lineProducCombo"
                [items]="lines"
                (selectedItemEvent)="changeLine($event)"
                label="{{ 'filters.line' | translate }}"
                (unselectItemEvent)="unselectedLine($event)"
                [disabled]="
                  last_filter_selection.subbrand == '' ||
                  last_filter_selection.subbrand == null
                "
                [selected]="last_filter_selection.line"
              ></dq-combo>
            </div>

            <div class="col-md-3">
              <dq-combo
                id="formatProducCombo"
                [items]="formats"
                (selectedItemEvent)="changeFormat($event)"
                label="{{ 'filters.format' | translate }}"
                (unselectItemEvent)="unselectedFormat($event)"
                [disabled]="
                  last_filter_selection.line == '' ||
                  last_filter_selection.line == null
                "
                [selected]="last_filter_selection.format"
              ></dq-combo>
            </div>
          </div>
        </li>

        <li class="list-group-item p-0">
          <div class="table-responsive">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" sortable="matnr" (sort)="onSort($event)">
                    {{ "pos.products.code" | translate }}
                  </th>
                  <th
                    scope="col"
                    sortable="description"
                    (sort)="onSort($event)"
                  >
                    {{ "pos.products.name" | translate }}
                  </th>
                  <th
                    scope="col"
                    sortable="classificationOrder"
                    (sort)="onSort($event)"
                  >
                    {{ "pos.products.classification" | translate }}
                  </th>
                  <th
                    scope="col"
                    sortable="lastPurschasedateOrder"
                    (sort)="onSort($event)"
                  >
                    {{ "pos.products.lastPurchase" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of productsPaginated; index as i">
                  <th scope="row">{{ i + 1 }}</th>
                  <td>{{ product.matnr }}</td>
                  <td>{{ product.description }}</td>
                  <td>
                    {{ product.classificationOrder }}
                  </td>
                  <td>
                    <span [class]="'badge badge-' + color(product)">
                      {{ product.lastPurchasedate | date: "mediumDate" }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="d-flex justify-content-between p-2">
              <ngb-pagination
                [collectionSize]="total"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="refreshProducts()"
                [maxSize]="3"
              >
              </ngb-pagination>

              <select
                class="custom-select"
                style="width: auto"
                [(ngModel)]="pageSize"
                (ngModelChange)="refreshProducts()"
              >
                <option [ngValue]="10">
                  10 {{ "common.perPage" | translate }}
                </option>
                <option [ngValue]="15">
                  15 {{ "common.perPage" | translate }}
                </option>
                <option [ngValue]="20">
                  20 {{ "common.perPage" | translate }}
                </option>
              </select>
            </div>

            <div class="d-flex justify-content-between p-2"></div>
          </div>
        </li>
      </ul>
    </div>
  </dq-accordion>
</div>
